import React, { useState, useEffect, useCallback, useRef } from 'react';
import styled from "styled-components";
import { CarouselImagesType } from './Types';
import { X } from 'react-bootstrap-icons';
import Loader from './Loader';

type CarouselProps = {
    imagesList: CarouselImagesType[],
    slideshow: boolean,
}

type CarouselImageProps = {
    $visible: boolean;
}

const Container = styled.div`
    position:relative;
    width: 28em;
    height: 18em;
    padding: 1em;
    @media (min-width: 770px) {
        margin-right:2em;
    }
`;

const ImageContainer = styled.div`
    position:absolute;
    left:0;
    top:0;
`;

const CarouselImage = styled.img<CarouselImageProps>`
    display: ${props => props.$visible == true ? "block" : "none"};
    width: 100%;
    cursor:pointer;
    -webkit-animation: fadeIn 2s;
    border: 3px solid var(--main-orange-color);
        @keyframes fadeIn {
            0% {
                opacity: 0.3;
            }

            100% {
                opacity: 1;
            }
        }
`;

const SelectorWrapper = styled.div`
    position:absolute;
    left:0;
    bottom:0;
    width:100%;
    display:flex;
    justify-content:center;
`;
const SelectorCircle = styled.div<CarouselImageProps>`
    height: 10px;
    width: 10px;
    margin:0.3em;
    background-color: ${props => props.$visible == true ? "var(--main-teal-color)" : "#fff"};
    border-radius: 50%;
    display: inline-block;
    transition: all 0.2s ease 0s;
    cursor:pointer;
        &:hover {
            transition: all 0.2s ease 0s;
            background-color: var(--main-teal-color);
        }
`;
const ImageModal = styled.div`
   display: block;
   position: fixed;
   z-index: 3;
   left: 0;
   top: 0;
   width: 100%;
   height: 100%;
   background-color: rgb(0,0,0);
   background-color: rgba(0,0,0,0.4);
`;
const NoImageContainer = styled.div`
   display: flex;
   justify-content:center;
   align-items:center;
`;
const ModalImageContainer = styled.div`
   display: flex;
   justify-content:center;
`;
const CloseIcon = styled(X)`
   color:#FFF;
   font-size: 2em;
   cursor:pointer;
`;
function Carousel({ imagesList, slideshow }: CarouselProps) {
    const [visibleImage, setVisibleImage] = useState<number>(0);
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [modalUrl, setModalUrl] = useState<string>("");
    const imageListLength = imagesList ? imagesList.length : 0;
    const timer = useRef<any>();

    useEffect(() => {

        if (imagesList && slideshow) {
            setVisibleImage(0);
            startTimer();
        }

        return () => clearInterval(timer.current)
    }, [imagesList]);

    const changeSlide = () => {
        setVisibleImage(prevState => prevState == imageListLength - 1 ? 0 : prevState + 1);
    }

    const startTimer = () => {
        timer.current = setTimeout(() => {
            changeSlide();
            startTimer();
        }, 5000);
    }

    const showImage = (index: number) => {
        setVisibleImage(index);
    }

    const viewModal = (url: string) => {
        setModalUrl(url);
        setModalVisible(true);
    }

    return (
        <Container>
            {imagesList ?
            <ImageContainer>
                {imagesList.map((image, i) => {
                    return (
                        <CarouselImage key={i} src={image.url} $visible={i == visibleImage} onClick={() => viewModal(image.url)} alt={image.alt} />
                    );
                })}
                <SelectorWrapper>
                    {imagesList && imagesList.map((image, i) => {
                        return (
                            <SelectorCircle key={i} $visible={i == visibleImage} onClick={() => showImage(i)} />
                        );
                    })}
                </SelectorWrapper>
            </ImageContainer> :
            <NoImageContainer>
                <Loader/>
            </NoImageContainer>
            }
            {modalVisible &&
            <ImageModal>
                <CloseIcon onClick={() => setModalVisible(false)} />
                <ModalImageContainer onClick={() => setModalVisible(false)}>
                    <img src={modalUrl} width="70%" alt="motorhome" onClick={(e) => e.stopPropagation()}/>
                </ModalImageContainer>
            </ImageModal>
            }
        </Container>
    );

}
export default Carousel;
